// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setMonth as fn } from "../setMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setMonth = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setMonth;
